import * as React from "react";
import { Edit, SimpleForm, TextInput, BooleanInput, required, minLength, maxLength } from 'react-admin';
import { useTranslate } from 'ra-core';
import { TagListInput } from "./TagListInput";
import { TagGroupActions } from "./TagGroupActions";

export const TagGroupEdit = (props) =>  {
    const { basepath } = props;
    const translate = useTranslate();
    return (
        <Edit mutationMode="optimistic" actions={<TagGroupActions basePath={basepath}/>} {...props}>
            <SimpleForm>
                <TextInput source="name" label={translate(`cmss.resources.tag-group.fields.name`)} validate={[required(), minLength(3), maxLength(255)]} options={{ autoComplete: 'off' }}  variant="outlined"/>
                <BooleanInput source="mandatory_on_upload" label={translate(`cmss.resources.tag-group.fields.mandatory-on-upload`)} />
                <TagListInput source="tags"/>
            </SimpleForm>
        </Edit>
    );
}
